import React from 'react';
import './TeamTab.css';



const TeamTab = ({
  teamId,
  teamMeta,
  role,
  directoryStatus,
  teamMembers,
  teamMembersLoading,
  teamMembersError,
  navigate,
  location,
}) => {
  const formatRole = (value) => {
    const roleValue = String(value || '').toLowerCase();
    if (roleValue === 'assistant_coach') return 'Assistant Coach';
    if (roleValue === 'coach') return 'Coach';
    if (roleValue === 'analyst') return 'Analyst';
    return 'Player';
  };

  const currentSeasonYear = String(new Date().getFullYear());
  return (
    <div className="settings-card">
      <h2>Team & Access</h2>
      <p className="settings-subtitle">
        See your current team and manage how you join or switch.
      </p>

      <div className="team-summary-card">
        {teamId ? (
          <>
            <h3>Your Team</h3>
            <p className="settings-subtitle">
              You&apos;re on team{' '}
              <span className="pill-strong">
                {teamMeta?.seasonName || teamMeta?.baseName || teamId}
              </span>{' '}
              as a <span className="pill-strong">{formatRole(role)}</span>.
            </p>
            <p className="settings-meta">
              Internal team ID (what you registered with):{' '}
              <span className="pill-strong">{teamMeta?.baseName || teamId}</span>
            </p>
            <p className="settings-meta">
              {currentSeasonYear} season team name comes from your Seasons tab for {currentSeasonYear}.
            </p>
          </>
        ) : (
          <>
            <h3>No Team Yet</h3>
            <p className="settings-subtitle">
              You&apos;re not on a team yet. Create one or request to join from the team pages.
            </p>
          </>
        )}
      </div>

      <button
        className="settings-btn"
        type="button"
        onClick={() =>
          navigate('/join-team', {
            state: {
              source: 'settings',
              from: `${location.pathname}${location.search}`,
            },
          })
        }
      >
        Browse Teams & Requests
      </button>
      {directoryStatus && <p className="settings-status">{directoryStatus}</p>}

      {teamId && (
        <div className="settings-team__members">
          <h3 className="team-members-heading">Team Members</h3>

          {teamMembersLoading && (
            <p className="settings-status">Loading members...</p>
          )}
          {teamMembersError && (
            <p className="settings-status">{teamMembersError}</p>
          )}
          {!teamMembersLoading && teamMembers.length === 0 && (
            <p className="settings-status">No members found for this team.</p>
          )}

          {teamMembers.length > 0 && (
            <div className="team-members-table-wrapper">
              <table className="team-members-table">
                <thead>
                  <tr>
                    <th>IGN</th>
                    <th>Email</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {teamMembers.map((m) => (
                    <tr key={m.id}>
                      <td>{m.ign || '—'}</td>
                      <td className="wrap-cell">{m.email || '—'}</td>
                      <td>
                        <span className="role-pill">{formatRole(m.role)}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TeamTab;
